import React from 'react';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import BasicLayout from 'layout/Basic';
import { convertProps } from 'lib/parseAPIResponse';
import EventContact, { Props } from 'containers/Events/Contact';

export const EventsContactPage = (props: Props) => {
    const { url } = getConfig().publicRuntimeConfig;
    const description =
        props.event.seoDescription || props.event.description?.replace(/<[^>]*>?/gm, '');

    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={props.event.seoTitle || props.event.name}
                canonical={`${url}/wydarzenia/${props.event.seoSlug}/kontakt`}
                description={description}
                openGraph={{
                    title: props.event.name,
                    description: description,
                    url: `${url}/wydarzenia/${props.event.seoSlug}/kontakt`
                }}
            />
            <EventContact {...props} />
        </BasicLayout>
    );
};

export async function getServerSideProps({ params }) {
    const slug = params.slug;
    const { apiUrl } = getConfig().publicRuntimeConfig;

    const path = `/public/api/events/${slug}/contact`;
    const url = apiUrl + path;
    return Promise.all([
        fetch(url),
        fetch(`${apiUrl}/public/api/naszadsik?path=events/${slug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return { props: { ...convertProps(ads), ...convertProps(data) } };
    });
}

export default EventsContactPage;
